import React from "react";
import { Form } from "antd";
import classNames from "classnames";
import { bg_button } from "constant/css";

const BankImageSelect = ({ banks, form }) => {
  const selectedBank = Form.useWatch("bankCode", form);

  const handleSelect = (value) => {
    form.setFieldsValue({ bankCode: value });
  };

  return (
    <Form.Item
      label="Төлбөр хүлээн авах банк сонгох"
      name="bankCode"
      rules={[{ required: true, message: "Банк сонгоно уу" }]}
    >
      <div className="flex gap-4 overflow-x-auto no-scrollbar">
        {banks.map((bank) => (
          <div
            key={bank.value}
            onClick={() => handleSelect(bank.value)}
            className={classNames(
              "cursor-pointer rounded-xl p-3 flex-shrink-0",
              selectedBank === bank.value ? `${bg_button}` : "w-[70px] h-[70px]"
            )}
            style={{ width: 80, borderRadius: 15 }}
          >
            <img
              src={bank.img}
              alt={bank.label}
              style={{ borderRadius: 15 }}
              className="rounded-xl object-contain"
            />
          </div>
        ))}
      </div>
    </Form.Item>
  );
};

export default BankImageSelect;
